import { useStore } from '@/utils/useStore'

const store = defineStore('users', () => {
  const { getItem, getItems, getAll, setItem, deleteItem, updateItem } = useStore('user', { indexes: [ 'username' ], priorityKeys: [ 'quizCompatibility', 'quizOption' ] })

  return {
    setItem, getItems, getItem, deleteItem, updateItem, getAll
  }
})

export default store